import { getConfiguration } from "./configuration";
import { isEntityToBeHiddenByDesc } from "./isEntityToBeHiddenByDesc";

export function isTournamentToBeHidden(tournamentId, desc) {
	let toHide = false;
	const entityRules = getConfiguration().eruls;
	if (entityRules != null) {
		const map = entityRules.htns;
		const hiddenById = map != null && map[tournamentId] != null;
		toHide = hiddenById || isEntityToBeHiddenByDesc(desc);
	}
	return toHide;
}
